import React from 'react'
import styles from './Legend.module.css'
import YearChange from './YearChange'

export default ({ label, symbols }) => (
  <div>
    <h3 className={styles.title}>{label}</h3>
    <div className={styles.legendContainer}>
      <ul className={styles.legend}>
        {Object.values(symbols)
          .sort((a, b) => a.order > b.order)
          .map((v, i) => (
            <li key={i}>
              <svg className={styles.color}>
                <path
                  d={v.d}
                  fill={v.fill}
                  transform="translate(5,5) scale(5)"
                />
              </svg>
              <span className="label">{v.label}</span>
            </li>
          ))}
      </ul>
    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/SymbolLegend.js